import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FormSelect, Container } from "shards-react";
import moment from "moment";
import { useUsersData } from "../../providers/UsersDataProvider";
import sdImage from "../../assets/dashboard/sd.svg";
import csdImage from "../../assets/dashboard/csd.svg";
import dbImage from "../../assets/dashboard/db.svg";
import threePlusImage from "../../assets/dashboard/3+.svg";
import eolImage from "../../assets/dashboard/eol.svg";
import changesImage from "../../assets/dashboard/changes.svg";
import guardianImage from "../../assets/dashboard/guardian.png";
import { checkDateForColorView } from "../../utils/common_handlers";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TablePaginationActions from "./TablePaginationActions";
import EnhancedTableHead from "./EnhancedTableHead";

const UsersTables = () => {
  const [filterText, setFilterText] = useState("");
  const [filterType, setFilterType] = useState("all");
  const { Users } = useUsersData();
  const [filteredUsers, setFilteredUsers] = useState(Users);
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("LastSessionDoneAt");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  useEffect(() => {
    if (filterText.length > 0) {
      let tempFilteredUsers = Users.filter(obj =>
        JSON.stringify(obj)
          .toLowerCase()
          .includes(filterText.toLowerCase())
      );
      if (filterType === "all") {
        setFilteredUsers(tempFilteredUsers);
      } else if (filterType === "Guardian") {
        tempFilteredUsers = tempFilteredUsers.filter(
          obj => obj.UserType === filterType
        );
        setFilteredUsers(tempFilteredUsers);
      } else if (filterType === "Training") {
        tempFilteredUsers = tempFilteredUsers.filter(
          obj => obj.UserType === filterType
        );
        setFilteredUsers(tempFilteredUsers);
      } else if (filterType === "child") {
        tempFilteredUsers = tempFilteredUsers.filter(
          obj => Number(obj.Age) <= 10
        );
        setFilteredUsers(tempFilteredUsers);
      } else if (filterType === "performedTests") {
        tempFilteredUsers = tempFilteredUsers.filter(
          obj => obj.performedTests === true
        );
        setFilteredUsers(tempFilteredUsers);
      } else {
        setFilteredUsers(tempFilteredUsers);
      }
    } else {
      setFilteredUsers(Users);
      let tempFilteredUsers = Users;
      if (filterType === "all") {
        setFilteredUsers(tempFilteredUsers);
      } else if (filterType === "Guardian") {
        tempFilteredUsers = tempFilteredUsers.filter(
          obj => obj.UserType === filterType
        );
        setFilteredUsers(tempFilteredUsers);
      } else if (filterType === "Training") {
        tempFilteredUsers = tempFilteredUsers.filter(
          obj => obj.UserType === filterType
        );
        setFilteredUsers(tempFilteredUsers);
      } else if (filterType === "performedTests") {
        tempFilteredUsers = tempFilteredUsers.filter(
          obj => obj.performedTests === true
        );
        setFilteredUsers(tempFilteredUsers);
      } else if (filterType === "child") {
        tempFilteredUsers = tempFilteredUsers.filter(
          obj => Number(obj.Age) <= 10
        );
        setFilteredUsers(tempFilteredUsers);
      } else {
        setFilteredUsers(tempFilteredUsers);
      }
    }
  }, [Users, filterText, filterType]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const makeUserStarred = async (uid, starValue) => {
    const userRef = doc(db, "UserData", uid);
    await updateDoc(userRef, {
      Starred: !starValue
    });
  };
  const makeUserAsSchoolKid = async (uid, value) => {
    const userRef = doc(db, "UserData", uid);
    await updateDoc(userRef, {
      SchoolKid: !value
    });
  };
  const searchBar = () => {
    return (
      <input
        className="form-control"
        type="text"
        value={filterText}
        onChange={e => {
          setFilterText(e.target.value);
        }}
        style={{ width: "50%" }}
      />
    );
  };

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelected = Users.map(n => n.FirstName);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  function descendingComparator(a, b, orderBy) {
    if (a[orderBy] === undefined) return 1; // `a` should come after `b`
    if (b[orderBy] === undefined) return -1; // `b` should come after `a`

    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  }

  const visibleRows = React.useMemo(
    () =>
      stableSort(filteredUsers, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [filteredUsers, order, orderBy, page, rowsPerPage]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "desc";
    setOrder(isAsc ? "asc" : "desc");
    setOrderBy(property);
  };

  return (
    <Container fluid className="main-content-container px-6">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "15px 20px"
        }}
      >
        <h6 className="m-0 font-weight-bold">Users</h6>
        <div className="d-flex gap-2" style={{ width: "30%" }}>
          <FormSelect
            onChange={e => setFilterType(e.target.value)}
            style={{ width: "50%" }}
          >
            <option value="all">All</option>
            <option value="Training">Training</option>
            <option value="Guardian">Guardian</option>
            <option value="performedTests">Performed Tests Today</option>
            <option value="child">Child</option>
          </FormSelect>
          {searchBar()}
        </div>
      </div>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        {Users.length < 1 ? (
          <div
            style={{
              height: "80vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <div className="spinner">
              <div className="spinner-1"></div>
              <div className="spinner-2"></div>
              <div className="spinner-3"></div>
            </div>
          </div>
        ) : (
          <TableContainer>
            <Table stickyHeader aria-label="sticky table">
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={Users.length}
              />{" "}
              <TableBody>
                {visibleRows &&
                  visibleRows.map(user => (
                    <TableRow
                      key={user.uid}
                      style={{
                        backgroundColor: user.performedTests
                          ? "lightblue"
                          : undefined
                      }}
                    >
                      <TableCell
                        align="center"
                        style={{
                          borderRight: "1px solid #d3d3d3",
                          fontSize: "12px"
                        }}
                      >
                        <NavLink
                          to={`/user-details/${user.uid}`}
                          style={{
                            color: "inherit",
                            fontSize: "0.9em",
                            fontWeight: 500,
                            padding: 0,
                            wordWrap: "break-word",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "30px"
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {user.FirstName +
                            (user.LastName ? " " + user.LastName : "")}
                          {user.UserType && user.UserType === "Guardian" && (
                            <img
                              className="guardianIcon"
                              src={guardianImage}
                              alt="Guardian"
                            />
                          )}
                        </NavLink>
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{
                          borderRight: "1px solid #d3d3d3",
                          fontSize: "12px"
                        }}
                      >
                        <div
                          className="centerItems"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "30px",
                            fontSize: "12px"
                          }}
                        >
                          {user.FirstSessionDoneOn
                            ? moment(
                                user.FirstSessionDoneOn.toDate().toDateString()
                              ).format("MMM Do YY")
                            : "-"}
                        </div>
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          borderRight: "1px solid #d3d3d3",
                          fontSize: "12px"
                        }}
                      >
                        <span
                          className="centerItems"
                          style={{
                            color: checkDateForColorView(
                              user.LastSessionDoneAt &&
                                user.LastSessionDoneAt.toDate().toDateString()
                            ),
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "30px",
                            fontSize: "12px"
                          }}
                        >
                          {user.LastSessionDoneAt
                            ? `${moment(
                                user.LastSessionDoneAt.toDate().toDateString()
                              ).format("MMM Do YY")}`
                            : "-"}
                        </span>
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          borderRight: "1px solid #d3d3d3",
                          fontSize: "12px"
                        }}
                      >
                        <div
                          className="centerItems"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "30px",
                            fontSize: "12px"
                          }}
                        >
                          {user.nextTestDate
                            ? moment(user.nextTestDate).format("MMM Do YY")
                            : "-"}
                        </div>
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{
                          borderRight: "1px solid #d3d3d3",
                          fontSize: "12px"
                        }}
                      >
                        <div
                          className="centerItems"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "30px",
                            fontSize: "12px"
                          }}
                        >
                          {user.CalibScore ? (
                            <>
                              <span>{user.CalibScore}</span>
                              {user.sign === "up" ? (
                                <i
                                  className="material-icons"
                                  style={{ cursor: "pointer", top: "0px" }}
                                >
                                  arrow_upward
                                </i>
                              ) : user.sign === "down" ? (
                                <i
                                  className="material-icons"
                                  style={{ cursor: "pointer", top: "0px" }}
                                >
                                  arrow_downward
                                </i>
                              ) : (
                                <i
                                  className="material-icons"
                                  style={{ cursor: "pointer", top: "0px" }}
                                >
                                  horizontal_rule
                                </i>
                              )}
                            </>
                          ) : (
                            "-"
                          )}
                        </div>
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{
                          borderRight: "1px solid #d3d3d3",
                          fontSize: "12px"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "30px",
                            fontSize: "12px"
                          }}
                        >
                          <div>
                            {user.StandardDeviation
                              ? user.StandardDeviation + "%"
                              : "-"}
                          </div>
                        </div>
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{
                          borderRight: "1px solid #d3d3d3",
                          fontSize: "12px"
                        }}
                      >
                        <div
                          className="centerItems"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "30px",
                            fontSize: "12px"
                          }}
                        >
                          {user.CalibrationStandardDeviation
                            ? user.CalibrationStandardDeviation + "%"
                            : "-"}
                        </div>
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{
                          borderRight: "1px solid #d3d3d3",
                          fontSize: "12px"
                        }}
                      >
                        <div
                          className="actionIconContainer centerItems actionColumn"
                          style={{ height: "30px" }}
                        >
                          <div className="actionIconWrapper">
                            {user.StandardDeviationIcon && (
                              <img
                                src={sdImage}
                                title={"Training Standard deviation"}
                                className="actionIcon"
                                alt="tsdIcon"
                              />
                            )}
                          </div>
                          <div className="actionIconWrapper">
                            {user.CalibrationStandardDeviationIcon && (
                              <img
                                src={csdImage}
                                title={"Calibration Standard deviation"}
                                className="actionIcon"
                                alt="csdIcon"
                              />
                            )}
                          </div>
                          <div className="actionIconWrapper">
                            {user.ReadCalibrationFromBackend && (
                              <img
                                src={dbImage}
                                title={"Read Calibration from backend"}
                                className="actionIcon"
                                alt="rdbIcon"
                              />
                            )}
                          </div>
                          <div className="actionIconWrapper">
                            {user.SessionDoneDaysAgo &&
                            user.SessionDoneDaysAgo >= 3 ? (
                              <img
                                src={threePlusImage}
                                title={"Session done 3 or more days ago"}
                                className="actionIcon"
                                alt="sessionDoneIcon"
                              />
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="actionIconWrapper">
                            {user.ValidTill &&
                            moment(
                              user.ValidTill.toDate().toDateString()
                            ).isBefore() ? (
                              <img
                                src={eolImage}
                                title={"Expired"}
                                className="actionIcon"
                                alt="expired"
                              />
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="actionIconWrapper">
                            {user.ChangeFlag && user.ChangeFlag && (
                              <img
                                src={changesImage}
                                title={"Changes made"}
                                className="actionIcon"
                                alt="changedMadeIcon"
                              />
                            )}
                          </div>
                          <div className="actionIconWrapper">
                            {user.UserAnswers && user.UserAnswers.length >= 1 && (
                              <span
                                className="actionIconText"
                                title={"Latest vergence test number"}
                              >
                                {user.UserAnswers.length}
                              </span>
                            )}
                          </div>
                          {/* <button type="button" className="btn btn-info" style={{ zIndex: 1 }} onClick={() => resetPasswordModal(row.Email)}>Reset Password</button>
          <button type="button" disabled={deletingUser && deletingUserId === row.uid} className="btn btn-danger" style={{ zIndex: 1 }}
            onClick={() => { deleteUser(row.uid) }}
          >
            Delete
          </button> */}
                        </div>
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{
                          borderRight: "1px solid #d3d3d3",
                          fontSize: "12px"
                        }}
                      >
                        <div className="rating centerItems" st>
                          <span
                            className={user.Starred ? "starred" : ""}
                            onClick={() =>
                              makeUserStarred(user.uid, user.Starred)
                            }
                          >
                            ☆
                          </span>
                        </div>
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{
                          borderRight: "1px solid #d3d3d3",
                          fontSize: "12px"
                        }}
                      >
                        <div className="centerItems" style={{ height: "30px" }}>
                          <div className="form-check ">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={user.SchoolKid ? true : false}
                              onChange={() =>
                                makeUserAsSchoolKid(user.uid, user.SchoolKid)
                              }
                            />
                          </div>
                        </div>
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{
                          borderRight: "1px solid #d3d3d3",
                          fontSize: "12px"
                        }}
                      >
                        {}
                        <a
                          className="centerItems"
                          target={"_blank"}
                          rel="noreferrer"
                          href={`https://statistics-imvi.web.app/Answers?Email=${encodeURIComponent(
                            user.Email
                          )}`}
                        >
                          <img
                            src={require("../../assets/dashboard/statistics.png")}
                            alt={"Report"}
                            title={"User Answers Report"}
                            style={{ width: "30px" }}
                          />
                        </a>
                      </TableCell>
                      {/* ... other columns ... */}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={filteredUsers && filteredUsers.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableContainer>
        )}
      </Paper>
    </Container>
  );
};

export default UsersTables;
